import { ControllerAPI } from "../api/api";
import createListApiState from "./lib/ListApiState";

export const [
    executionsSlice,
    loadExecutions,
    updateExecutionsManually
] = createListApiState({
    name: "Executions",
    execute: ControllerAPI.loadExecutions
});
